import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../Service/app-service';

@Component({
  selector: 'app-report-table',
  templateUrl: './report-table.component.html',
  standalone: true,
  imports: [CommonModule, NgxSpinnerModule],
  styleUrls: ['./report-table.component.css']
})
export class ReportTableComponent implements OnInit {
  transactionId: number = 0;
  totalRecords = 0;
  successCount = 0;
  skippedCount = 0;
  failedCount = 0;
  filtereduser: any[] = [];
  paginateduser: any[] = [];
  sortColumn = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  currentPage2 = 1;
  rowsPerPage2 = 5;
  totalPages2 = 1;

  constructor(
    private route: ActivatedRoute,
    private reportService: AuthService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.transactionId = params['id'];
      this.fetchDetails();
    });
  }

  fetchDetails() {
    this.spinner.show();
    this.reportService.getExcelResultById(this.transactionId).subscribe({
      next: (res: any) => {
        this.totalRecords = res.totalRecords;
        this.successCount = res.statusCount.SUCCESS || 0;
        this.skippedCount = res.statusCount.SKIPPED || 0;
        this.failedCount = res.statusCount.FAIL || 0;
        this.filtereduser = res.details;
        this.updatePaginationuser();
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error("Failed to load report");
      }
    });
  }

  downloadReport() {
    this.spinner.show();
    this.reportService.downloadExcelResult(this.transactionId).subscribe({
      next: (file: Blob) => {
        const url = window.URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Report_${this.transactionId}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.spinner.hide();
        this.toastr.success("Downloaded successfully");
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error("Download failed");
      }
    });
  }

  sortuser(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.filtereduser.sort((a, b) => {
      const x = a[column];
      const y = b[column];
      return this.sortDirection === 'asc' ? (x > y ? 1 : -1) : (x < y ? 1 : -1);
    });
    this.updatePaginationuser();
  }

  updatePaginationuser() {
    this.totalPages2 = Math.ceil(this.filtereduser.length / this.rowsPerPage2);
    const start = (this.currentPage2 - 1) * this.rowsPerPage2;
    const end = start + this.rowsPerPage2;
    this.paginateduser = this.filtereduser.slice(start, end);
  }

  changePage2(page: number) {
    if (page < 1 || page > this.totalPages2) return;
    this.currentPage2 = page;
    this.updatePaginationuser();
  }

  isValidPage(page: number) {
    return page >= 1 && page <= this.totalPages2;
  }

  getPagesuser() {
    return Array.from({ length: this.totalPages2 }, (_, i) => i + 1);
  }

  getStartIndex() {
    return this.filtereduser.length === 0 ? 0 : (this.currentPage2 - 1) * this.rowsPerPage2 + 1;
  }

  getEndIndex() {
    const end = this.currentPage2 * this.rowsPerPage2;
    return end > this.filtereduser.length ? this.filtereduser.length : end;
  }

  goBack() {
    window.history.back();
  }

  goBackToHome() {
    this.router.navigate(['/home']);
  }

}